<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div class="header-side"></div>
  <div class="dialog-title-text" cdkDragHandle>
    {{ getHeaderText() }}
  </div>
  <button mat-icon-button class="close-btn" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <form [formGroup]="toteTxForm" class="form-grid">
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Customer</mat-label>
        <mat-select (selectionChange)="onGeneratorChange($event.value)" id="generatorSelect"
          data-testid="generatorSelect" formControlName="customerID">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #generatorFilterInput matInput placeholder="Search customer..." (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()" (input)="onGenSearchQuery($event)" />

            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          @for (generator of filteredGenerators(); track generator.id) {
          <mat-option [value]="generator.id">
            {{ generator.customerName }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Streams</mat-label>
        <mat-select id="streamSelect" (selectionChange)="onStreamChange($event.value)" data-testid="streamSelect"
          formControlName="streamID" name="stream" (opened)="onStreamDropdownOpen()">
          <div class="mat-select-search-container" (click)="$event.stopPropagation()">
            <input #streamSearchInput matInput placeholder="Search Stream..." (input)="onStreamSearchQuery($event)"
              class="mat-select-search-input" aria-label="Search Stream" (keydown)="$event.stopPropagation();" />
            <mat-icon class="mat-select-search-icon">search</mat-icon>
          </div>
          @for (stream of filteredStreams(); track stream.id) {
          <mat-option [value]="stream.id">{{ stream.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Transaction Date</mat-label>
        <input matInput [matDatepicker]="txDatePicker" formControlName="transactionDate" id="transactionDateInput"
          (keydown)="onKeydown($event)" (blur)="dateformat($event)"
          data-testid="transactionDateInput" />
        <mat-datepicker-toggle matIconSuffix [for]="txDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #txDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Transaction Status</mat-label>
        <mat-select id="transactionStatusSelect" data-testid="transactionStatusSelect"
          formControlName="transactionStatusId" name="transactionStatusId">
          @for (txStatus of transactionStatues(); track txStatus.id) {
          <mat-option [value]="txStatus.id"
            [disabled]="(txStatus.name === 'Invoiced' || txStatus.name === 'Invoice N/A')">{{ txStatus.name
            }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

    </div>
    <div class="form-grid-row">
      <mat-form-field appearance="outline">
        <mat-label>Transaction Types</mat-label>
        <mat-select id="transactionTypeSelect" data-testid="transactionTypeSelect" formControlName="transactionTypeId"
          name="transactionTypeId">
          @for (txType of transactionTypes(); track txType.id) {
          <mat-option [value]="txType.id">{{
            txType.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Fee</mat-label>
        <input matInput type="text" formControlName="fee" id="feeInput" data-testid="feeInput"
          (input)="roundOff($event, 9999, 4, 'fee')" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Notes</mat-label>
        <textarea matInput formControlName="notes" id="notesInput" data-testid="notesInput" rows="3" maxlength="150"></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button (click)="cancel()" type="button" mat-raised-button color="primary">
    Cancel
  </button>
  @if(canSave){
    <button type="button" (click)="onSubmit()" mat-raised-button color="primary"
      [disabled]="toteTxForm.invalid || !toteTxForm.dirty">
      Save
    </button>
  }
</mat-dialog-actions>